export enum Flags {
  'show-accounts-settings-main-nav-item-20240726-enabled' = 'show-accounts-settings-main-nav-item-20240726-enabled',
  'show-commerce-settings-main-nav-item-20231127-enabled' = 'show-commerce-settings-main-nav-item-20231127-enabled',
  'create-commerce-platform-experience-20231127-enabled' = 'create-commerce-platform-experience-20231127-enabled',
  'guest-questions-self-serve-temp-20231214-enabled' = 'guest-questions-self-serve-temp-20231214-enabled',
  'AR-live-self-service-temp-20240208-enabled' = 'AR-live-self-service-temp-20240208-enabled',
  'show-waitlist-support-20240228-enabled' = 'show-waitlist-support-20240228-enabled',
  'live-self-service-translations-20240320-enabled' = 'live-self-service-translations-20240320-enabled',
  'self-service-translations-20240812-enabled' = 'self-service-translations-20240812-enabled',
  'webhook-settings-self-serve-temp-20240313-enabled' = 'webhook-settings-self-serve-temp-20240313-enabled',
  'ota-redeam-self-serve-temp-202410524-enabled' = 'ota-redeam-self-serve-temp-202410524-enabled',
  'capacity-per-ticket-type-20240509-enabled' = 'capacity-per-ticket-type-20240509-enabled',
  'anyroad-internal-09052024-enabled' = 'anyroad-internal-09052024-enabled',
  'activity-logs-temp-20250321-enabled' = 'activity-logs-temp-20250321-enabled',
  'activity-logs-booking-id-filter-temp-20250618-enabled' = 'activity-logs-booking-id-filter-temp-20250618-enabled',
  'message-all-guests-20250903-enabled' = 'message-all-guests-20250903-enabled',
  'sbp-in-core-20250924-enabled' = 'sbp-in-core-20250924-enabled',
  'discounts-20251003-enabled' = 'discounts-20251003-enabled',
  'event-tracking-checkout-02112026-enabled' = 'event-tracking-checkout-02112026-enabled',
  'ai-insights-20260114-enabled' = 'ai-insights-20260114-enabled',
  'location-question-20260304-enabled' = 'location-question-20260304-enabled',
}
